import { Shield } from 'lucide-react';
import LegalDocumentPage from '../components/LegalDocumentPage';

export default function PrivacyPolicy() {
  return (
    <LegalDocumentPage
      title="Privacy Policy"
      pdfPath="/privacy-policy.pdf"
      icon={Shield}
      intro="This page hosts SkipdQ’s Privacy Policy. The full legal text is in the PDF below. We collect account, order, pickup, and payment metadata needed to operate the service; card numbers are handled by Stripe."
    />
  );
}
